import { render } from "./UniversalPopover.vue?vue&type=template&id=cb5d0824&scoped=true"
import script from "./UniversalPopover.vue?vue&type=script&lang=js"
export * from "./UniversalPopover.vue?vue&type=script&lang=js"

import "./UniversalPopover.vue?vue&type=style&index=0&id=cb5d0824&lang=less&scoped=true"

import exportComponent from "/aqua/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb5d0824"]])

export default __exports__